import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ element: Component }) => {
    let storedToken;
    let storedUser;

    // Intentar obtener el token y el usuario almacenado en sessionStorage
    try {
        storedUser = sessionStorage.getItem('userActivo');
        storedToken = sessionStorage.getItem('Esttoken');
    } catch (error) {
        console.error("Error parsing stored token:", error);
        storedToken = null;
        storedUser = null;
    }
    // console.log(storedToken)
    // console.log(storedUser)
    // Verificar si el token y el usuario son válidos
    // const isTokenValid = (storedToken === "TokenValido") && (storedUser === 1); // Asegúrate de comparar el usuario de la manera correcta
    // console.log("VALI?::", isTokenValid)
    if (storedToken === "TokenValido" && storedUser === "1") {
        return <Component />;
    } else {
        return <Navigate to="/login" />;
    }
};

export default PrivateRoute;
